import loadSimulation from './loadSimulation';

export default {
  loadSimulation,
};
